var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-file-listing"
  }, [_c('b-table', {
    key: _vm.componentKey,
    ref: "table",
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "show-empty": "",
      "fields": _vm.fields,
      "items": _vm.allFiles,
      "primary-key": "id",
      "caption-top": "",
      "caption-html": "Attached Files"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "raftjs-empty-text"
        }, [_vm._v("\n        " + _vm._s(_vm.emptyText) + "\n      ")])];
      }
    }, {
      key: "cell(id)",
      fn: function (data) {
        var _data$item, _data$item2, _data$item3, _data$item4, _data$item5, _data$item6, _data$item6$uri;
        return [_vm.allowFileDownload && data !== null && data !== void 0 && (_data$item = data.item) !== null && _data$item !== void 0 && _data$item.filename ? _c('b-link', {
          staticClass: "file-download",
          attrs: {
            "id": 'download-' + (data === null || data === void 0 ? void 0 : (_data$item2 = data.item) === null || _data$item2 === void 0 ? void 0 : _data$item2.id)
          },
          on: {
            "click": function ($event) {
              return _vm.downloadFile(data);
            }
          }
        }, [_vm._v("\n        " + _vm._s(data === null || data === void 0 ? void 0 : (_data$item3 = data.item) === null || _data$item3 === void 0 ? void 0 : _data$item3.filename) + "\n        "), _c('b-img', {
          staticClass: "download-icon",
          attrs: {
            "src": _vm.PathMapper.getIconAssetPath('download.png', _vm.$isB4),
            "alt": "Click here to download file"
          }
        })], 1) : data !== null && data !== void 0 && (_data$item4 = data.item) !== null && _data$item4 !== void 0 && _data$item4.name ? _c('span', [_vm._v("\n        " + _vm._s(data === null || data === void 0 ? void 0 : (_data$item5 = data.item) === null || _data$item5 === void 0 ? void 0 : _data$item5.name) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.showFileUrl ? _c('p', [_c('em', [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : (_data$item6 = data.item) === null || _data$item6 === void 0 ? void 0 : (_data$item6$uri = _data$item6.uri) === null || _data$item6$uri === void 0 ? void 0 : _data$item6$uri.url))])]) : _vm._e()];
      }
    }, {
      key: "cell(filemime)",
      fn: function (data) {
        var _data$item7;
        return [_vm._v("\n      " + _vm._s((data === null || data === void 0 ? void 0 : (_data$item7 = data.item) === null || _data$item7 === void 0 ? void 0 : _data$item7.filemime) || _vm.singleFileData[0].filemime) + "\n    ")];
      }
    }, _vm.singleFileData ? {
      key: "cell(filesize)",
      fn: function (data) {
        return [_vm._v("\n      " + _vm._s(_vm.singleFileData[0].filesize) + "\n    ")];
      }
    } : null, _vm.allowFileRemove && !_vm.disabled ? {
      key: "cell(delete_action)",
      fn: function (data) {
        var _data$item8;
        return [_c('b-link', {
          staticClass: "file-delete",
          attrs: {
            "id": 'delete-' + (data === null || data === void 0 ? void 0 : (_data$item8 = data.item) === null || _data$item8 === void 0 ? void 0 : _data$item8.id)
          },
          on: {
            "click": function ($event) {
              var _data$item9;
              return _vm.deleteAttachedFile(data === null || data === void 0 ? void 0 : (_data$item9 = data.item) === null || _data$item9 === void 0 ? void 0 : _data$item9.id);
            }
          }
        }, [_vm._v("\n        Delete\n      ")])];
      }
    } : null], null, true)
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }